import { createSelector } from 'reselect';

export const getSimCardAccesor = state => state.stock.simcards;

export const simCardSelector = createSelector(getSimCardAccesor, simcards => simcards);

export const getSimCardByIccid = createSelector(
  [getSimCardAccesor, (_, iccid) => iccid],
  (simcards, iccid) => {
    if (!iccid || !simcards.simCards) return null;
    return simcards.simCards.find(sim => sim.iccid === iccid) || null;
  }
);